import { useSelector } from "react-redux";
import { useAccount, useReadContract } from "wagmi";
import useDappConfig from "./useDappConfig";
import { toFixedWithoutRounding } from "@constants/common";
import { formatUnits, maxUint256 } from "viem";
import { ETH } from "@config/contractsConfig";

const useTokenAllowance = () => {
  const { selectedERC20 } = useSelector((state: any) => state.user);
  const { address: walletAddress } = useAccount();

  const { config } = useDappConfig();

  const token = config.tokens[selectedERC20];

  const { data } = useReadContract({
    ...token,
    functionName: "allowance",
    args: [walletAddress, config.interactionPools.lrtDepositPool.address],
    query: {
      enabled: !!walletAddress && selectedERC20 !== ETH,
      refetchInterval: 10_000,
      initialData: 0n,
    },
  });

  return {
    erc20Allowance:
      selectedERC20 !== ETH
        ? +toFixedWithoutRounding(
            data
              ? formatUnits(
                  data as bigint,
                  config.tokens[selectedERC20].decimals
                )
              : "0",
            8
          )
        : +toFixedWithoutRounding(
            formatUnits(maxUint256, config.nativeToken.decimals),
            8
          ),
  };
};

export default useTokenAllowance;
